import { Link } from "react-router";
import { PageHeader } from "../components/PageHeader";
import { siteConfig } from "../config/site";

export function InfoPage() {
  return (
    <section className="mx-auto w-full max-w-6xl px-5 py-6 sm:p-10 lg:p-12">
      <PageHeader eyebrow="INFO // COMPANY" title={siteConfig.infoTitle} />

      <div className="grid gap-px border border-zinc-800 bg-zinc-800 lg:grid-cols-[1.1fr_0.9fr]">
        <article className="bg-[#090909] p-8">
          <p className="font-mono text-[9px] tracking-[0.22em] text-zinc-600">
            STATEMENT
          </p>
          <p className="mt-5 max-w-2xl text-2xl font-light leading-9 tracking-[-0.02em] text-zinc-200">
            {siteConfig.statement.map((line, index) => (
              <span key={line}>
                {index > 0 ? <br /> : null}
                {line}
              </span>
            ))}
          </p>
        </article>

        <aside className="bg-[#0b0b0b] p-8">
          <p className="font-mono text-[9px] tracking-[0.22em] text-zinc-600">
            TEAM
          </p>
          <dl className="mt-3.5 border border-zinc-800 bg-[#0a0a0a]">
            {siteConfig.team.map((member) => (
              <div
                key={member.name}
                className="grid grid-cols-[6.5rem_minmax(0,1fr)] border-b border-zinc-800 last:border-b-0"
              >
                <dt className="border-r border-zinc-800 p-3 font-mono text-[8px] tracking-[0.18em] text-zinc-700">
                  {member.name}
                </dt>
                <dd className="m-0 p-3 font-mono text-[9px] tracking-[0.12em] text-zinc-400">
                  {member.role}
                </dd>
              </div>
            ))}
          </dl>
        </aside>
      </div>

      <div className="mt-10">
        <div className="mb-4 flex items-center justify-between">
          <p className="font-mono text-[9px] tracking-[0.22em] text-zinc-600">
            CAPABILITIES
          </p>
          <span className="h-px w-24 bg-zinc-800" aria-hidden="true" />
        </div>

        <div className="grid gap-px border border-zinc-800 bg-zinc-800 sm:grid-cols-2">
          {siteConfig.capabilities.map((capability) => (
            <article key={capability.code} className="min-h-52 bg-[#0a0a0a] p-8">
              <span className="font-mono text-[9px] tracking-[0.2em] text-zinc-700">
                {capability.code}
              </span>
              <h2 className="mt-10 text-lg font-light tracking-[0.04em] text-zinc-100">
                {capability.title}
              </h2>
              <p className="mt-4 max-w-md text-sm font-light leading-7 text-zinc-500">
                {capability.description}
              </p>
            </article>
          ))}
        </div>
      </div>

      <div className="mt-10 grid gap-px border border-zinc-800 bg-zinc-800 lg:grid-cols-[1.1fr_0.9fr]">
        <div className="bg-[#090909] p-8">
          <p className="font-mono text-[9px] tracking-[0.22em] text-zinc-600">
            CONTACT
          </p>
          <h2 className="mt-5 max-w-[520px] text-2xl font-light leading-9 tracking-[-0.02em] text-zinc-200">
            {siteConfig.infoContact.heading}
          </h2>
          <Link
            to="/contact"
            className="mt-7 inline-flex items-center gap-4 border border-zinc-100 bg-zinc-100 px-5 py-3.5 font-mono text-[9px] tracking-[0.2em] text-black transition-colors hover:bg-transparent hover:text-zinc-100 focus-visible:bg-transparent focus-visible:text-zinc-100 focus-visible:outline-none"
          >
            {siteConfig.infoContact.cta}
            <span aria-hidden="true">→</span>
          </Link>
        </div>

        <aside className="bg-[#0b0b0b] p-8">
          <p className="font-mono text-[9px] tracking-[0.22em] text-zinc-600">
            EMAIL
          </p>
          <a
            href={`mailto:${siteConfig.infoContact.email}`}
            className="mt-4 block font-mono text-sm tracking-[0.06em] text-zinc-100 transition-colors hover:text-zinc-400 focus-visible:text-zinc-400 focus-visible:outline-none"
          >
            {siteConfig.infoContact.email}
          </a>
          <p className="mt-5 max-w-96 text-[13px] font-light leading-[1.7rem] text-zinc-500">
            {siteConfig.infoContact.note}
          </p>
        </aside>
      </div>
    </section>
  );
}
